import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { getClockFormat } from "reduxSlices/currentSettingsSlice"
import ItemRow from "shared/ItemRow"
import { ProfileIcon } from "shared/icons"
import { orgLocalDateTimeByClockFormat } from "utils/dateHelpers"
import HistoricalAccessToolActionFilters from "./HistoricalAccessToolActionFilters"

const HistoricalAccessToolAction = ({ action }) => {
  const clockFormat = useSelector(getClockFormat)

  return (
    <>
      <ItemRow
        collapsable
        itemRowHeaderControls
        itemRowHeaderContent={(
          <>
            <div className="flex">
              <div className="flex items-center screenreader-whitespace">
                <ProfileIcon user={action.grantor} className="w-4 h-4" />
                <b className="ml-2"> {action.grantor.fullName} </b>
                <span className="ml-1"> {action.actionType === "Grant" && `added ${action.accessLevel.replace("_", " ")}`} </span>
                <span className="ml-1"> {action.actionType === "Revoke" && "removed access"} </span>
              </div>
            </div>
            <div>
              {orgLocalDateTimeByClockFormat(action.createdAt, clockFormat)}
            </div>
          </>
        )}
        itemRowBody={<HistoricalAccessToolActionFilters action={action} />}
      />
    </>
  )
}

HistoricalAccessToolAction.propTypes = {
  action: types.object.isRequired,
}

export default HistoricalAccessToolAction
